<div class="container-fluid" style="padding: 0">
  <div class="row pt-3 mb-3">
    <div class="col-md-12 text-right">
      <!-- <button type="button" class="btn btn-dark" (click)="onDownloadReport()">Download Report</button> -->
    </div>
  </div>

  <div class="ng-Header col-xs-12 mt-2">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Decision
  </div>

  <nz-descriptions nzTitle="Basic Information" style="padding: 10px">
    <nz-descriptions-item nzTitle="Name of STP/SAC">
      {{ inspectionDecisionInfo?.stpName }}</nz-descriptions-item
    >
    <nz-descriptions-item nzTitle="STP/SAC ID">{{
      inspectionDecisionInfo?.stpRegistrationNo
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Application ID">{{
      inspectionDecisionInfo?.applicationId
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Date of Application">{{
      inspectionDecisionInfo?.applicationDate | date: "dd-MM-YYYY"
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Date of Inspection Conducted">{{
      inspectionDecisionInfo?.inspectionConductedDate | date: "dd-MM-YYYY"
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="GPS Location">NA</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Inspection Conducted By-1"
      >{{ this.designation }}
      <!-- {{ nsdaOfficerName }} -->
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Inspection Conducted By-2">{{
      inspectionDecisionInfo?.inspectorOfficer1
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Inspection Conducted By-3">{{
      inspectionDecisionInfo?.inspectorOfficer2
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Inspection Conducted By-4">{{
      inspectionDecisionInfo?.inspectorOfficer3
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Date of Scrutiny Completed">{{
      inspectionDecisionInfo?.scrutinyCompleteDate
        ? (inspectionDecisionInfo?.scrutinyCompleteDate | date: "dd-MM-YYYY")
        : "NA"
    }}</nz-descriptions-item>
  </nz-descriptions>
      <app-stp-action-history
        *ngIf="stpMainId && applicationId"
        [stpMainId]="stpMainId"
        [applicationId]="applicationId"
      ></app-stp-action-history>
  <div class="ng-Header col-xs-12 mt-2">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Details Inspection
    Report
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicTable
      [nzData]="detailsInspectionReportList"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr style="overflow: auto">
          <th style="width: 70px; text-align: center" rowspan="1">Sl.</th>
          <th style="text-align: center" rowspan="2">Application for</th>
          <th style="text-align: center" rowspan="2">Application Type</th>
          <th style="text-align: center" rowspan="2">
            Scrutiny Result for STP/SAC Registration
          </th>
          <th style="text-align: center" rowspan="2">
            Scrutiny Result for Course Accreditaion
          </th>
          <th style="text-align: center" rowspan="2">
            Scrutiny Result for Assessment center Accreditation
          </th>

          <!-- <th style="text-align: center" rowspan="2">Action</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>

          <td style="text-align: center">{{ data?.occupationName }}</td>
          <td style="text-align: center">{{ data?.applicationType }}</td>
          <td style="text-align: center">
            {{
              data?.scrutinyResultRegistration
                ? data?.scrutinyResultRegistration
                : "NA"
            }}
          </td>
          <td style="text-align: center">
            {{
              data?.scrutinyResultForCourseAccreditation
                ? data?.scrutinyResultForCourseAccreditation
                : "NA"
            }}
          </td>
          <td style="text-align: center">
            {{
              data?.scrutinyResultForAssessmentCenterAccreditation
                ? data?.scrutinyResultForAssessmentCenterAccreditation
                : "NA"
            }}
          </td>
          <!-- <td style="text-align: left">
              <button (click)="showModal(data)" nz-button nzType="primary" [nzSize]="'small'">
                <i nz-icon nzType="edit" nzTheme="outline"></i>Decision
              </button>
              <i *ngIf="data?.isUpdated" style="margin-left: 5px; font-size: 20px" nz-icon [nzType]="'check-circle'"
                [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>
              |
              <button type="button" *ngIf="data.type=='Occupation'" (click)="onView(data.inspectionResultId)" nz-button nzType="default"
                [nzSize]="'small'">
                <i nz-icon nzType="eye" nzTheme="fill"></i>
              </button>
              <button type="button" *ngIf="data.type=='STP'" (click)="onViewStpSac(inspectionId)" nz-button nzType="default" [nzSize]="'small'">
                <i nz-icon nzType="eye" nzTheme="fill"></i>
              </button>
            </td> -->
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- <div class="col-md-12 col-sm-12 col-lg-12 mt-2">
          <nz-form-item>

            <nz-form-control>
              <nz-form-label>Rollback Remarks</nz-form-label>
              <textarea

                nz-input
                placeholder="Remarks"
                [formControl]="upDatedRemarks"
                id="pandaMarts "
              ></textarea>

            </nz-form-control>
          </nz-form-item>
        </div> -->

  <div>
    <div class="row justify-content-center">
      <!-- <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionRollback()" [disabled]="rollbackBtnDisabled" nz-button nzType="primary"
          style="margin-top: 15px">
          Rollback
        </button>
        <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionSave()" [disabled]="enableSaveAndSubmitBtn" nz-button nzType="primary"
          style="margin-top: 15px; margin-left: 20px;">
          Save
        </button>
        <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionSubmit()" [disabled]="!isSubmitAll" nz-button nzType="primary"
          style="margin-top: 15px; margin-left: 20px;">
          Submit Decision
        </button> -->
      <button
        class="col-md-2 col-sm-12 mt-2"
        (click)="showModalAllData()"
        nz-button
        nzType="primary"
        style="margin-top: 15px; margin-left: 20px"
      >
        Decision
      </button>
    </div>
    <br />
  </div>
</div>

<!-- Current Application Types(currentApplicationTypeId)
           1 = Course Accreditation
           2 = Assessment Center Accreditation
           3 = Course and Assessment Center Accreditation
           4 = Registration Application -->

<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Renewal / Re-apply Decision and Validity"
  (nzOnCancel)="handleCancel()"
>
  <div *nzModalContent>
    <!-- Specific div for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation -->
    <div *ngIf="currentApplicationTypeId == 4">
      <form nz-form nzLayout="vertical" [formGroup]="firstForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 4"
              >Final Decision for STP/SAC Registration
            </nz-form-label>

            <!-- First Dropdown for STP/SAC Registration -->
            <div *ngIf="currentApplicationTypeId == 4" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="firstSelect"
                  nzShowSearch
                  nzAllowClear
                  formControlName="firstSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onFirstSelectFirstForm($event)"
                >
                  <nz-option
                    *ngFor="
                      let recommendation of recommendationTypeListForRegistration
                    "
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>

            <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId != 4" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="firstSelect"
                  nzShowSearch
                  nzAllowClear
                  formControlName="firstSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onFirstSelectFirstForm($event)"
                >
                  <nz-option
                    *ngFor="let recommendation of recommendationTypeList"
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label
            [nzRequired]="firstForm.get('firstSelect')?.value == approveId"
            >Valid From To Till Date</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledFromTodayDate"
                  formControlName="fromDate"
                  (ngModelChange)="updateToDateFirstForm($event)"
                ></nz-date-picker>
                <span style="margin: 0 5px"></span>
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  formControlName="toDate"
                  [nzDisabled]="
                    firstForm.get('firstSelect')?.value != approveId
                  "
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="currentApplicationTypeId == 1">
      <form nz-form nzLayout="vertical" [formGroup]="thirdForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 1"
              >Final Decision for Course Accreditaion
            </nz-form-label>

            <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId == 1" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="firstSelect"
                  nzShowSearch
                  nzAllowClear
                  formControlName="firstSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onFirstSelectThirdForm($event)"
                >
                  <nz-option
                    *ngFor="let recommendation of recommendationTypeList"
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label
            [nzRequired]="thirdForm.get('firstSelect')?.value == approveId"
            >Valid From To Till Date</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledFromTodayDate"
                  formControlName="fromDate"
                  (ngModelChange)="updateToDateThirdForm($event)"
                ></nz-date-picker>
                <span style="margin: 0 5px"></span>
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  formControlName="toDate"
                  [nzDisabled]="
                    thirdForm.get('firstSelect')?.value != approveId
                  "
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="currentApplicationTypeId == 2">
      <form nz-form nzLayout="vertical" [formGroup]="fourthForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 2"
              >Final Decision for Assessment center Accreditation</nz-form-label
            >

            <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId == 2" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="firstSelect"
                  nzShowSearch
                  nzAllowClear
                  formControlName="firstSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onFirstSelectFourthForm($event)"
                >
                  <nz-option
                    *ngFor="let recommendation of recommendationTypeList"
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label
            [nzRequired]="fourthForm.get('firstSelect')?.value == approveId"
            >Valid From To Till Date</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledFromTodayDate"
                  formControlName="fromDate"
                  (ngModelChange)="updateToDateFourthForm($event)"
                ></nz-date-picker>
                <span style="margin: 0 5px"></span>
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  formControlName="toDate"
                  [nzDisabled]="
                    fourthForm.get('firstSelect')?.value != approveId
                  "
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <!-- Specific div for ONLY Course and Assessment Center Accreditation -->
    <div *ngIf="currentApplicationTypeId == 3">
      <form nz-form nzLayout="vertical" [formGroup]="secondForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired
              >Final Decision for Course Accreditaion</nz-form-label
            >
            <div class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="firstSelect1"
                  nzShowSearch
                  nzAllowClear
                  formControlName="firstSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onFirstSelectSecondForm($event)"
                >
                  <nz-option
                    *ngFor="let recommendation of recommendationTypeList"
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-12">
          <nz-form-label
            [nzRequired]="secondForm.get('firstSelect')?.value == approveId"
            for="validDateRange"
            >Valid From To Till Date</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="secondForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="courseDateChange($event)"></nz-range-picker> -->
                <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange" [(ngModel)]="selectedRange"
                  [nzDisabled]="secondForm.get('firstSelect')?.value != approveId" (ngModelChange)="onRangeChange($event)"></nz-range-picker> -->
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledFromTodayDate"
                  formControlName="fromDate"
                  (ngModelChange)="updateToDateSecondForm($event)"
                ></nz-date-picker>
                <span style="margin: 0 5px"></span>
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  formControlName="toDate"
                  [nzDisabled]="
                    secondForm.get('firstSelect')?.value != approveId
                  "
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired
              >Final Decision for Assessment center Accreditation</nz-form-label
            >
            <div class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select
                  id="secondSelect"
                  nzShowSearch
                  nzAllowClear
                  formControlName="secondSelect"
                  nzPlaceHolder="Select from List"
                  (ngModelChange)="onSecondSelectSecondForm($event)"
                >
                  <nz-option
                    *ngFor="let recommendation of recommendationTypeList"
                    [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name"
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-12">
          <nz-form-label
            [nzRequired]="secondForm.get('secondSelect')?.value == approveId"
            for="validDateRangeLast"
            >Valid From To Till Date</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="assessmentDateRanges" id="validDateRangeLast" formControlName="validDateRangeLast"
                  [nzDisabled]="secondForm.get('secondSelect')?.value != approveId" (nzOnCalendarChange)="assessmentDateChange($event)"></nz-range-picker> -->
                <!-- <nz-range-picker id="validDateRangeLast" formControlName="validDateRangeLast"
                  [nzDisabled]="secondForm.get('secondSelect')?.value != approveId"></nz-range-picker> -->
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledFromTodayDate"
                  formControlName="fromDateLast"
                  (ngModelChange)="updateToDateLastSecondForm($event)"
                ></nz-date-picker>
                <span style="margin: 0 5px"></span>
                <nz-date-picker
                  nzFormat="dd-MM-yyyy"
                  formControlName="toDateLast"
                  [nzDisabled]="
                    secondForm.get('secondSelect')?.value != approveId
                  "
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()">Submit</button>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="isVisibleAll"
  [nzTitle]="titleTpl"
  [nzWidth]="1200"
  [nzBodyStyle]="{ 'max-height': '60vh', 'overflow-y': 'auto' }"
  [nzStyle]="{ top: '20px' }"
  (nzOnCancel)="handleCancelAll()"
>
  <ng-template #titleTpl>
    STP/SAC Registration Final Decision for Application ID:
    <strong style="color: #1890ff">{{ applicationId }}</strong>
  </ng-template>
  <form nz-form [formGroup]="decisionForm">
    <div formArrayName="applications">
      <div
        *ngFor="let app of applications.controls; let i = index"
        [formGroupName]="i"
        class="mb-1 border pt-2 pl-3"
      >
        <!-- Specific div for ONLY STP/SAC Registration -->
        <ng-container *ngIf="app.get('applicationTypeId')?.value == 4">
          <!-- <nz-form-label> -->
          <a
            (click)="onViewStpSac(this.inspectionId)"
            nz-tooltip
            nzTooltipTitle="View Details"
            nzTooltipPlacement="topRight"
          >
            {{ app.get("occupationName")?.value }}
          </a>
          :
          <!-- </nz-form-label> -->
          <span style="color: black; font-weight: bold">
            (Scrutiny Result -
            <span style="color: blue">{{
              app.get("scrutinyResultRegistration")?.value
            }}</span
            >)
          </span>

          <div class="row">
            <div class="col-md-2">
              <nz-form-label nzRequired>Final Decision</nz-form-label>
              <nz-form-item>
                <nz-form-control>
                  <nz-select
                    nzShowSearch
                    nzAllowClear
                    formControlName="finalDecisionId"
                    nzPlaceHolder="Select from List"
                    (ngModelChange)="onSelectDecision(i)"
                  >
                    <nz-option
                      *ngFor="let r of recommendationTypeListForRegistration"
                      [nzValue]="r.id"
                      [nzLabel]="r.name"
                    ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="col-md-4">
              <nz-form-label
                [nzRequired]="app.get('finalDecisionId')?.value == approveId"
                >Valid From To Till Date</nz-form-label
              >
              <nz-form-item>
                <nz-form-control>
                  <nz-date-picker
                    nzFormat="dd-MM-yyyy"
                    formControlName="validFrom"
                    (ngModelChange)="onValidFromChange(i)"
                  >
                  </nz-date-picker>

                  <span style="margin: 0 5px"></span>

                  <nz-date-picker
                    nzFormat="dd-MM-yyyy"
                    formControlName="validTo"
                    [nzDisabledDate]="disabledStpToDate(i)"
                    [nzDisabled]="
                      app.get('finalDecisionId')?.value != approveId
                    "
                  >
                  </nz-date-picker>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>

  <div
    *nzModalFooter
    class="d-flex justify-content-between align-items-center flex-wrap gap-2"
  >
    <div *ngIf="this.isRollbackRemarks" class="col-md-12 col-sm-12 mt-2">
      <nz-form-item>
        <nz-form-control>
          <textarea
            nz-input
            placeholder="Rollback Remarks"
            [formControl]="rollbackRemarks"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="d-flex flex-column">
      <button
        *ngIf="!isRollbackRemarks"
        [disabled]="rollbackBtnDisabled"
        type="button"
        class="btn btn-warning"
        (click)="showRollbackRemarks()"
      >
        Rollback
      </button>
      <button
        *ngIf="isRollbackRemarks"
        [disabled]="rollbackBtnDisabled"
        type="button"
        class="btn btn-warning"
        nz-popconfirm
        nz-tooltip
        nzTooltipPlacement="topLeft"
        nzPopconfirmTitle="Are you sure to rollback this application?"
        (nzOnConfirm)="onAssesmentDecisionRollback()"
      >
        Confirm Rollback
      </button>
    </div>

    <!-- Right side: Save & Submit + Cancel -->
    <div class="d-flex align-items-center gap-2">
      <button
        [disabled]="!isSubmitAll"
        nz-button
        nzType="primary"
        nz-popconfirm
        nz-tooltip
        nzTooltipPlacement="topLeft"
        nzPopconfirmTitle="Are you sure to save & submit the decision? Once submitted, you can not change it anymore."
        (nzOnConfirm)="onAssessmentDecisionSave()"
      >
        Save & Submit Decision
      </button>

      <button nz-button nzType="default" (click)="handleCancelAll()">
        Cancel
      </button>
    </div>
  </div>
</nz-modal>
